const UploadIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M14 10.9121V11.7121C14 12.8322 14 13.3923 13.782 13.8201C13.5903 14.1964 13.2843 14.5024 12.908 14.6941C12.4802 14.9121 11.9201 14.9121 10.8 14.9121H5.2C4.07989 14.9121 3.51984 14.9121 3.09202 14.6941C2.71569 14.5024 2.40973 14.1964 2.21799 13.8201C2 13.3923 2 12.8322 2 11.7121V10.9121M11.3333 6.24544L8 2.91211M8 2.91211L4.66667 6.24544M8 2.91211V10.9121"
        stroke="#0056D6"
        strokeWidth="1.11111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default UploadIcon;
